"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ConfirmationMainContent_1 = require("../confirmationMainContent/ConfirmationMainContent");
var ReserveOnlineMessage_1 = require("./ReserveOnlineMessage");
var ConfirmationReserveOnlineVisanet = function () {
    return (<core_1.Box data-test="payment:visanet:confirmation">
      <ConfirmationMainContent_1.default>
        <ReserveOnlineMessage_1.default />
      </ConfirmationMainContent_1.default>
    </core_1.Box>);
};
exports.default = ConfirmationReserveOnlineVisanet;
